import { FEATURE_NAME } from './constants'
import { GlobalState } from './reducer'
import { createSelector } from 'reselect'

const select = (state: GlobalState) => state[FEATURE_NAME]

export const getCurrentLanguage = createSelector(select, state => state.currentLanguage)

export const getI18nMap = createSelector(select, state => state.i18nMap)
